<template>
  <section :id="data.id" class="quote-section">
    <div class="container">
      <div
        class="is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
      >
        <h1 class="title" v-html="data.title"></h1>
        <p v-html="data.paragraph" class="tertiary-title"></p>
      </div>
    </div>

    <div class="container">
      <carousel
        :items="1"
        :responsive="{
          0: { items: 1, nav: false },
          600: { items: 1, nav: false }
        }"
        class="is-variable is-1 overflow-hidden-class"
      >
        <template slot="prev">
          <span
            class="button-primary__icon icon icon--arrow-left-hair carousel-icon"
          >
            <span class="loader-base button-primary__loader"></span>
          </span>
        </template>
        <div
          class="quote"
          v-for="benefit in data.benefits"
          :key="benefit.index"
        >
          <div class="carousel-content">
            <div class="column is-full-desktop image-wrapper">
              <img
                :class="{
                  desktop: true,
                  ...benefit.classes
                }"
                :src="
                  `https://static.porscheautoinsurance.com/images/homepage/${
                    benefit.image
                  }${benefit.image_ext ? '.' + benefit.image_ext : '.jpg'}`
                "
                alt
              />
              <img
                  :class="{
                  mobile: true,
                  ...benefit.classes
                }"
                  :src="
                  `https://static.porscheautoinsurance.com/images/homepage/mobile_${
                    benefit.image
                  }${benefit.image_ext ? '.' + benefit.image_ext : '.jpg'}`
                "
                  alt
              />
            </div>
            <div
              :class="{
                column: true,
                'is-full-desktop': true,
                'content-wrapper': true,
                ...benefit.classes
              }"
              :style="{ ...benefit.styling }"
            >
              <p v-html="benefit.paragraph"></p>
              <span
                class="break-name"
                style="font-size:0.75rem;letter-spacing:0;"
                >- {{ benefit.author }}</span
              >
            </div>
          </div>
        </div>
        <template slot="next">
          <span
            class="button-primary__icon icon icon--arrow-right-hair carousel-icon"
          >
            <span class="loader-base button-primary__loader"></span>
          </span>
        </template>
      </carousel>
      <div class="reference-numbers" v-if="data.references">
        <div v-for="(reference, index) in data.references" :key="index">
          <span v-html="reference"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import carousel from 'vue-owl-carousel';

export default {
  name: 'Benefits',
  components: {
    carousel
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
p,
li {
  font-size: 1rem;
  line-height: 1.5rem;
}
span.break-name {
  font-size: 1rem;
  line-height: 1.5rem;
  display: block;
  @media (max-width: 760px) {
    padding: 0 0 2rem 2rem;
  }
}
.quote-section {
  min-height: 0px;
  padding: $--pcom-spacing-large 0 $--pcom-spacing-x-large;

  .quote {
    color: white;
    font-size: 1.5em;
    line-height: 1.5em;
  }
  .columns {
    margin-top: 0;
    margin-bottom: 0;
  }

  .column {
    display: flex;
    padding-top: 0;
    padding-bottom: 0;

    &.content-wrapper {
      @media (max-width: 760px) {
        margin-bottom: 2rem;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
  .overflow-hidden-class {
    overflow: hidden;
  }
  .wrapper {
    background-color: $black;
    color: $white;
    position: relative;
    display: block;
    text-decoration: none;
  }

  .image-wrapper {
    display: block;
    overflow: hidden;
    max-height: 600px;
    //max-width: 900px;
    padding: 0;
  }

  img {
    display: block;
    flex-shrink: 0;
    max-width: 100vw;
    min-width: 100%;

    &.benefits_01 {
      @media (min-width: 1300px) and (max-width: 1499px) {
        margin-top: 0;
      }

      @media (min-width: 1500px) {
        margin-top: -4rem;
      }

      @media (min-width: 1800px) {
        margin-top: -10rem;
      }

    }

    &.quote_02 {
      width: 100%;
      @media (max-width: 1200px) {
        width: unset;
      }
      @media (min-width: 1200px) and (max-width: 1599px) {
        margin-top: -1rem;
      }

      @media (min-width: 1600px) {
        margin-top: -5rem;
      }

    }

    &.image-3 {
      margin-top: 0;
      padding-bottom: 0;

      @media (min-width: 1200px) and (max-width: 1399px) {
        margin-top: -5rem;
        width: 100%;
      }

      @media (min-width: 1400px) and (max-width: 1599px) {
        margin-top: -10rem;
        width: 100%;
      }

      @media (min-width: 1600px) {
        margin-top: -15rem;
        width: 100%;
      }
    }
  }
  .carousel-content {
    position: relative;
  }
  .content-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    flex-direction: column;
    justify-content: center;

    &.benefits_01 {
      letter-spacing: 0.1rem;
      color: $white;
      top: 8%;
      float: left;
      padding-right: clamp(20vw, 60%, 40vw);
      width: 100%;
      text-align: right;
      font-family: 'PorscheNextRegular', 'Arial Narrow', Arial, sans-serif;
      font-weight: 600;
      @media (max-width: 800px) {
        padding-right: clamp(20vw, 40%, 15vw);
        top: 75%;
      }
      @media (min-width: 800px) and (max-width: 899px) {
        padding-right: clamp(20vw, 55%, 25vw);
        top: 75%;
      }
      @media (min-width: 900px) and (max-width: 1023px) {
        padding-right: clamp(20vw, 65%, 32vw);
        top: 80%;
      }
      @media (min-width: 1024px) and (max-width: 1200px) {
        padding-right: clamp(20vw, 65%, 40vw);
        top: 80%;
      }
      @media (min-width: 1200px) and (max-width: 1499px) {
        color: $primary;
        padding-right: clamp(20vw, 65%, 45vw);
      }
      @media (min-width: 1500px) {
        color: $primary;
        padding-right: clamp(20vw, 65%, 52vw);
      }
    }
    &.quote_02 {
      letter-spacing: 0.1rem;
      color: #fff;
      top: 80%;
      float: right;
      padding-right: 50%;
      width: 100%;
      text-align: right;
      font-family: 'PorscheNextRegular', 'Arial Narrow', Arial, sans-serif;
      font-weight: 600;
      @media (max-width: 599px) {
        padding-right: 0.75rem;
        p {
          font-size: 0.75rem;
        }
      }
      @media (min-width: 600px) and (max-width: 799px) {
        padding-right: 2rem;
      }
      @media (min-width: 800px) and  (max-width: 1099px) {
        padding-right: clamp(20vw, 50%, 25vw);
      }
      @media (min-width: 1100px) {
        padding-right: clamp(20vw, 50%, 40vw);
        top: 15%;
      }
    }
  }

  .secondary-title {
    font-family: $family-sans-serif;
    font-size: 2.25rem;
    padding: 0 0 10px;

    @media (max-width: 986px) {
      font-size: 1.75rem;
      line-height: 28px;
    }
  }

  .subtitle {
    font-size: 1.25rem;
    line-height: 26px;
    margin: 0 !important;
    padding: 20px 20px 10px;
    color: $black;

    @media (min-width: 768px) {
      line-height: 30px;
    }

    @include from($tablet) {
      font-size: 1.4rem;
    }

    @include until($widescreen) {
      font-size: 1.4rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.5rem;
    }
  }

  p {
    margin: 0;
    padding: 0;
  }

  .reference-numbers {
    font-size: 0.8rem;
    padding-top: 0.5rem;
  }

  .container {
    position: relative;
    .carousel-icon {
      font-size: 3rem;
      display: block;
      @media (max-width: 768px) {
        display: none;
      }
    }
    .icon--arrow-left-hair {
      left: 4%;
      top: 35%;
      @media (max-width: 1400px) {
        left: 2%;
      }
    }
    .icon--arrow-right-hair {
      right: 4%;
      top: 35%;
      @media (max-width: 1400px) {
        right: 2%;
      }
    }
  }
}
</style>
<style lang="scss">
.owl-carousel {
  z-index: unset;
  .owl-stage {
    display: flex;
  }
}
.owl-stage-outer {
  background-color: $primary;
  border-radius: 12px;
  width: calc(100% - 5px);
}
.owl-theme .owl-dots .owl-dot.active span {
  background: red !important;
}
button.owl-dot {
  outline: none !important;
}
.width-class {
  width: 100%;
}
</style>
